window.customElements.define("mega-menu", class Megamenu extends HTMLElement {

    megamenuCurrentClass = 'megamenu--current';
    megamenuVisibleClass = 'megamenu--isVisible';
    megamenuAnimateClass = 'megamenu--animate';
    bodyClass = 'megamenu--isActive';
    megamenuElClass = '[id^="shopify-section-sections"] #megamenu';
    mainNavTarget = 'header .header__menu-item.megamenu-item';
    curtainTarget = 'mega-menu-curtain';
    megamenuEl = null;
    timer = null;
    menuLinkHoverDuration = 100;

    constructor() {
        super();
    }

    connectedCallback() {
      this.addCurtain();
      this.addMeganavToHeader();

      // Event listeners
      this.windowEventScroll();
      this.linkEventMouseover();
      this.curtainEventClick();
      this.linkEventMouseout();
      this.curtainEventMouseover();
      this.observeHeaderHover();
      this.megamenuEventMouseover();
      this.megamenuEventMouseleave();
    }

    disconnectedCallback() {
      if (this.megamenuEl) this.megamenuEl.remove();
    }

    // Methods
    addCurtain() {
      if (document.getElementById('megamenu')) return;
      this.innerHTML = '<mega-menu-curtain></mega-menu-curtain>' + this.innerHTML;
    }

    addMeganavToHeader() {
      document.querySelector('[id^="shopify-section-sections"] .header-wrapper').insertAdjacentHTML('afterend', this.innerHTML)
      this.innerHTML = '';
      this.megamenuEl = document.querySelector(this.megamenuElClass);
    }

    removeAnimation() {
      this.megamenuEl.classList.remove(this.megamenuAnimateClass);
      document.body.classList.remove(this.bodyClass);
    }

    showMegamenuItem(menuItemEl) {
      if (!menuItemEl) return;

      let megamenuId = "megamenu-" + window.handleize(menuItemEl.innerText);
      let megamenuItemEl = document.getElementById(megamenuId);

      if (!megamenuItemEl) {
        this.hideAllMenuItems();
        this.removeAnimation();
        clearTimeout(this.timer);
        return;
      }

      let timerHoverDuration = (this.menuIsVisible()) ? 0 : this.menuLinkHoverDuration;

      let self = this;
      this.timer = setTimeout(function() {
        // prepare menu for animation
        document.body.classList.add(self.bodyClass);
        self.megamenuEl.classList.add(self.megamenuAnimateClass);

        // show mega menu item
        setTimeout(function() {
          self.hideAllMenuItems();
          menuItemEl.classList.add(self.megamenuCurrentClass);
          megamenuItemEl.classList.add(self.megamenuVisibleClass);
        }, timerHoverDuration)
      }, timerHoverDuration);
    }

    hideAllMenuItems() {
      // hide mega menu item
      let currentMenuItems = document.querySelectorAll('.' + this.megamenuCurrentClass);
      if (currentMenuItems) {
        for (var i=0; i < currentMenuItems.length; i++) {
          let currentMenuItem = currentMenuItems[i];
          currentMenuItem.classList.remove(this.megamenuCurrentClass);
        }
      };

      let visibleMenuItems = document.querySelectorAll('.' + this.megamenuVisibleClass);
      if (visibleMenuItems) {
        for (var i=0; i < visibleMenuItems.length; i++) {
          let visibleMenuItem = visibleMenuItems[i];
          visibleMenuItem.classList.remove(this.megamenuVisibleClass);
        }
      };
    }

    menuIsVisible() {
      return (document.querySelector('#megamenu.megamenu--animate')) ? true : false;
    }

    // Event Listeners
    curtainEventClick() {
      const self = this;
      document.addEventListener('click', function(e) {
        if (!e.target.closest(self.curtainTarget)) return false;
        self.hideAllMenuItems();
        self.removeAnimation();
      });
    }

    curtainEventMouseover() {
      const self = this;
      document.addEventListener('mouseover', function(e) {
        if (!e.target.closest(self.curtainTarget)) return false;
        if (!self.menuIsVisible()) return;

        clearTimeout(self.timer);
        self.hideAllMenuItems();
        self.removeAnimation();
      });
    }

    windowEventScroll() {
      const self = this;
      window.addEventListener('scroll', function(e) {
        self.hideAllMenuItems();
        self.removeAnimation();
      })
    }

    linkEventMouseover() {
      const self = this;
      document.addEventListener('mouseover', function(e) {
        if (!e.target.closest(self.mainNavTarget)) return false;
        self.showMegamenuItem(e.target);
      });
    }

    linkEventMouseout() {
      const self = this;
      document.addEventListener('mouseout', function(e) {
        if (!e.target.closest(self.mainNavTarget)) return false;
        clearTimeout(self.timer);
      });
    }

    megamenuEventMouseover() {
      const self = this;
      document.addEventListener('mouseover', function(e) {
        if (!e.target.closest(self.megamenuElClass)) return false;
        document.body.style.overflow = 'hidden';
      });
    }

    megamenuEventMouseleave() {
      const self = this;
      document.addEventListener('mouseout', function(e) {
        if (!e.target.closest(self.megamenuElClass)) return false;
        document.body.style.overflow = '';
      });
    }

    observeHeaderHover(){
      this.headers = document.querySelectorAll('.section-header, .announcement-bar-section');
      this.headers.forEach(item => {
        item.addEventListener("mouseleave", (event) => {
          const self = this;
          self.hideAllMenuItems();
          self.removeAnimation();
        });
      })
    }

})